import { CanvasType, PosterType } from '@/version-types';

/**
 * 判断是否是 PPT
 *
 * @param type - 画布类型
 */
export const checkCanvasTypeIsPPT = (type: CanvasType) => {
    if (CanvasType.PPT === type) {
        return true;
    }

    return false;
};

/**
 * 判断是否是普通 PPT
 *
 * @param postType - 海报类型
 */
export const checkPosterTypeIsNormalPPT = (postType: PosterType) => {
    if (PosterType.NormalPPT === postType) {
        return true;
    }

    return false;
};

/**
 * 判断是否是 AI PPT
 *
 * @param postType - 海报类型
 */
export const checkPosterTypeIsAiPPT = (postType: PosterType) => {
    if (PosterType.AiPPT === postType) {
        return true;
    }

    return false;
};
